export default {
  /**
   * @return {Number} 前回のデータ取得からの経過時間（分）
   */
  timeDiff ({ loading, currentTimestamp, fetchedTimestamp }) {
    if (loading) return -1
    return fetchedTimestamp
      ? Math.round(Math.abs(((currentTimestamp - fetchedTimestamp) / (1000 * 60))))
      : -1
  },
  /**
   * @return {object} 選択してあるエリアの、設定してある期間（週、月）内のデータ一式
   */
  getGroupData (state) {
    const opts = ['weeklyArray', 'monthlyArray']
    const data = state[opts[state.selectedSpan]]

    return data.length
      ? data.find(d => d.groupId === state.area)
      : null
  },
  /**
   * @return { { total: Number, installed: Number } } タンク総数と設置センサー数
   */
  getTankInfo (state, getters) {
    let installed = 0
    let total = 0
    if (getters.getGroupData) {
      const { tankInfo } = getters.getGroupData
      installed = tankInfo.sensorInstalled
      total = tankInfo.total
    }

    return { installed, total }
  },
  /**
   * @return { [Number[], Number[], { count: Number, amount: Number }] } [配送件数／日]、[配送量／日]、{(期間内の合計) 配送件数, 配送量}
   */
  getGraphData (state, getters) {
    let count = 0
    let amount = 0
    const data = [[], [], { count, amount }]
    if (getters.getGroupData) {
      const { supplies } = getters.getGroupData
      supplies.forEach(e => {
        data[0].push(e.count)
        data[1].push(e.amount)
        data[2].count += e.count
        data[2].amount += e.amount
      })
    }

    return data
  },
  /**
   * @return { [{ count: Number, amount: Number }, { count: Number, amount: Number }] } [前年の累計, 今年の累計]
   */
  getYearlyData (state, getters) {
    const data = [
      {
        count: 0,
        amount: 0
      },
      {
        count: 0,
        amount: 0
      }
    ]

    if (getters.getGroupData) {
      const { lastYear, thisYear } = getters.getGroupData
      data[0].amount = lastYear.amount
      data[0].count = lastYear.count
      data[1].amount = thisYear.amount
      data[1].count = thisYear.count
    }

    return data
  }
}
